import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useSnackbar } from 'notistack';
import { ContentHead } from '../../lib/components';
import { ContentBox } from '../../lib/components/compound/pages/contentBox';
import { Button } from '../../lib/components/atomic/button';
import { CardOverviewTable } from '../../lib/components/tables/pxtraCardOverview/cards';
import { downloadBlob } from '../../lib/util';
import { useStore } from '../../hooks/useStore';
import { useExportCards } from '../../queries/pxtraCard';
import { CardOnboardingNotice } from '../../lib/components/compound/pxtraCardOnboarding';

export const CardOverview = observer(() => {
  const { t } = useTranslation();
  const { companyStore } = useStore();
  const { enqueueSnackbar } = useSnackbar();
  const companyId = companyStore.company?.id ?? '';

  const { mutate: exportCards, isPending } = useExportCards(companyId);

  const download = () =>
    exportCards(undefined, {
      // The proxy in front of the backend drops Content-Disposition, so the
      // file is named here.
      onSuccess: (blob: Blob) => downloadBlob(blob, t('pxtraCard:exportFilename')),
      onError: () => enqueueSnackbar(t('pxtraCard:exportFailed'), { variant: 'error' })
    });

  return (
    <ContentBox
      headComponent={
        <ContentHead
          headline={t('pxtraCard:cards')}
          subtitle={t('pxtraCard:cardsSubtitle')}
          showActions
          renderActions={() => (
            <Button variant="secondary" size="small" disabled={isPending} onClick={download}>
              {t('pxtraCard:exportCsv')}
            </Button>
          )}
        />
      }
    >
      <CardOnboardingNotice />
      <CardOverviewTable />
    </ContentBox>
  );
});
